import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Link, useParams, useNavigate } from "react-router-dom";
import MetaData from '../../layout/MetaData'
import {useUpdateDriverStatusMutation, useGetOrderDetailsDriverQuery, useUpdateDriverOrderMutation, useAcceptDriverBookingMutation } from "../../../redux/api/driverApi";
import "../../../css/Driver.css"
import { useSelector } from "react-redux";
import Loader from '../../layout/Loader'

const PotentialBookingDetails = () => {
  const navigate = useNavigate();

  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

  const { user } = useSelector((state) => state.auth); // Extract user details

  const [adminProposedAmount, setAdminProposedAmount] = useState("");
  const [status, setStatus] = useState("");

  const [updateDriverOrder, 
    // { error, isSuccess }
  ] = useUpdateDriverOrderMutation();

  const [acceptDriverBooking, { error: acceptError, isSuccess: acceptSuccess }] = useAcceptDriverBookingMutation();
  const [updateDriverStatus, { error, isSuccess }] = useUpdateDriverStatusMutation();

  const params = useParams();
  const { data, isError, error: fetchError } = useGetOrderDetailsDriverQuery(params?.id, {
    pollingInterval: 1000,
  });
  

  const order = data?.order || {}

  const {
    userAddressInfo,
    googleMap,
    labour,
    goodsInfo,
    orderStatus,
    totalAmount,
    userRecieved
  } = order;

  useEffect(() => {
    // 🛑 Handle fetch error first
    if (isError || (fetchError && fetchError?.data?.message === "Order not found")) {
      toast.error("یہ بکنگ بند کر دی گئی ہے");
      setTimeout(() => {
        navigate("/");
      }, 5000);
      return; // Exit early
    }
  
    // 🛑 Handle updateDriverOrder error
    if (error) {
      const message = error?.data?.message;
      toast.error(message);
  
      if (message === 'یہ بکنگ کینسل کر دی گئی ہے') {
        setTimeout(() => {
          navigate("/");
        }, 45000);
      }
  
      return; // Exit early to avoid showing unrelated toasts
    }
  
    // ✅ Show success only if there’s no fetch or mutation error
    if (isSuccess) {
        toast.success("Booking Updated Successfully")
      // toast.success("آپ کی طرف سے مانگی ہوئی رقم ڈال دی گئ ہے");
    }
  
    if (acceptError) {
      toast.error(acceptError?.data?.message);
    }
  
    // if (acceptSuccess) {
    //   toast.success("Booking accepted successfully!");
    // }
  }, [error, isSuccess, acceptError, acceptSuccess, navigate, isError, fetchError]);
  

  // Update proposed amount
  const updateProposedOrderHandler = (id) => {
    const data = { adminProposedAmount };
    updateDriverOrder({ id, body: data });
  };

  const updateDriverStatusHandler = (id) => {
    // e.preventDefault();
    const data = {status,};
    updateDriverStatus({ id, body: data });
  };


  // Accept booking function
  const acceptBooking = (id) => {
    if (!user) {
      toast.error("User not logged in.");
      return;
    }

    const data = {  
      driverID: user?._id,
      driverName: user?.name,
      driverPhoneNo: user?.phoneNo,
      driverVehicleNumber: user?.driverVehicleNumber,
      driverVehicleMakeModel: user?.driverVehicleMakeModel, 
      driverVehicleCapacity: user?.driverVehicleCapacity,
      avatar: user?.avatar?.url,  
      CNIC: user?.CNIC?.url,
      drivingLicense: user?.drivingLicense?.url, 
      vehicleRegistration: user?.vehicleRegistration?.url 
    };

    acceptDriverBooking({ id, body: data });
  };


  return (
    <>
      <MetaData title={"Order Details Driver"} />
      <div className="row d-flex justify-content-around">
        <div className="col-12 col-lg-8 order-details">

        <br></br>        

        {orderStatus !== "Waiting for user to accept" && (
          <>
  <table className="table table-striped table-bordered">
            <tbody>

            <tr>
  {orderStatus === "Vehicle not dispatched yet" && ( 
    <>
     <h3 style={{ textAlign: "center" }}>اپ کو یہاں پے جاناہے</h3>
            <br />
            <br /> 
  <td>
  <h5 className="text-center">
  {userAddressInfo?.startAddress},
  <br/>
   {googleMap?.origin}
   </h5>

   <img 
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${googleMap?.origin}&zoom=18&size=600x300&markers=color:red%7C${googleMap?.origin}&key=${googleMapsApiKey}`} 
        alt="Static Map" 
        style={{ width: "100%", borderRadius: "10px" }}
      />

  </td> 
   </>
)}

{orderStatus === "Vehicle Dispatched" && ( 
    <>
     <h3 style={{ textAlign: "center" }}>اپ کو یہاں پے جاناہے</h3>
            <br />
            <br /> 
  <td>
  <h5 className="text-center">
  {userAddressInfo?.startAddress}, 
  <br/>

   {googleMap?.origin}
   </h5>

   <img 
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${googleMap?.origin}&zoom=18&size=600x300&markers=color:red%7C${googleMap?.origin}&key=${googleMapsApiKey}`} 
        alt="Static Map" 
        style={{ width: "100%", borderRadius: "10px" }}
      />

  </td> 
   </>
)}

{orderStatus === "Vehicle Arrived At pickup location" && ( 
    <>
     <h3 style={{ textAlign: "center" }}>اپ کو یہاں پے جاناہے</h3>
            <br />
            <br /> 
  <td>
  <h5 className="text-center">
  {userAddressInfo?.destinationAddress},
  <br/>

   {googleMap?.destination}
   </h5>

   <img 
  src={`https://maps.googleapis.com/maps/api/staticmap?center=${googleMap?.destination}&zoom=18&size=600x300&markers=color:red%7C${googleMap?.destination}&key=${googleMapsApiKey}`} 
  alt="Static Map" 
        style={{ width: "100%", borderRadius: "10px" }}
      />

  </td>
   </>
)}

{orderStatus === 'Vehicle has left from pick up location' && ( 
    <>
     <h3 style={{ textAlign: "center" }}>اپ کو یہاں پے جاناہے</h3>
            <br />
            <br /> 
  <td>
  <h5 className="text-center">
  {userAddressInfo?.destinationAddress},
    <br/>
   {googleMap?.destination}
   </h5>

   <img 
  src={`https://maps.googleapis.com/maps/api/staticmap?center=${googleMap?.destination}&zoom=18&size=600x300&markers=color:red%7C${googleMap?.destination}&key=${googleMapsApiKey}`} 
  alt="Static Map" 
        style={{ width: "100%", borderRadius: "10px" }}
      />

  </td> 
   </>
)}

{orderStatus === 'Vehicle Arrived At Destination location' && ( 
    <>
         <h3 style={{ textAlign: "center" }}>اپ کو یہاں پے جاناہے</h3>
            <br />
            <br /> 
  <td>
    <h5 className="text-center">
  {userAddressInfo?.destinationAddress},
   {googleMap?.destination}
   </h5>

   <img 
  src={`https://maps.googleapis.com/maps/api/staticmap?center=${googleMap?.destination}&zoom=18&size=600x300&markers=color:red%7C${googleMap?.destination}&key=${googleMapsApiKey}`} 
  alt="Static Map" 
        style={{ width: "100%", borderRadius: "10px" }}
      />

  </td>
    <td>
    </td>
   </>
)}
 
{orderStatus === 'Job Completed Successfully' && ( 
    <>
  <td>
  <h1 className="text-center">یہ بکنگ کمپلیٹ ہوگئ ہے</h1>
  </td>
    <td>
    </td>
   </>
)}

</tr>
</tbody>
</table>
</>
)}

        {orderStatus === "Waiting for user to accept" && (
        <>
      <div className="d-flex justify-content-between align-items-center">
      <h3 className="centerh1findingdriver">Waiting for user to accept...</h3>
      </div>
      <div className='loader-booking-detail'>
      <Loader />
      </div> 
      </>
    )}


{orderStatus === "Vehicle Arrived At Destination location" && userRecieved === false && (
  <>
    <br />
    <div className="d-flex justify-content-between align-items-center">
      <h3 className="centerh1findingdriver">
        سامان کے مالک کو بولے سامان ملگیا والا باٹن دبا دے
      </h3>
    </div>
    <div className='loader-booking-detail'>
      <Loader />
    </div>
  </>
)}


{userRecieved && (
  <div className="text-center mt-4">
    <button
      className="btn btn-success px-4 py-2 fw-bold"
      onClick={() =>
        updateDriverStatus({
          id: order?._id,
          body: { status: "Job Completed Successfully" },
        })
      }
    >
      <h2>✅ کام پورا ہوگیا</h2>
    </button>
  </div>
)}




          <table className="table table-striped table-bordered">
            <tbody>
              <h3 className="mt-5 mb-4">Pricing & Status</h3>

              {orderStatus !== "Finding Driver" && (
            <tr>
                <th scope="row"><h4>سواری کی معلومات</h4></th>
                <td>     
                <div className="mb-3">
              <label htmlFor="status_field" className="form-label">
              Status
              </label>
              <select
                id="status_field"
                className="form-select"
                name="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                {/* <option value="Vehicle not dispatched yet">گاڑی روانہ نہیں ہوئی</option> */}
                <option value="null">Select Status</option>
                <option value="Vehicle Dispatched">گاڑی روانہ ہو گئی ہے</option>
                <option value="Vehicle Arrived At pickup location">گاڑی سامان اٹھانے کے مقام پر پہنچ گئی ہے</option>
                <option value="Vehicle has left from pick up location">گاڑی سامان اٹھانے کے مقام سے روانہ ہو گئی ہے</option>
                <option value="Vehicle Arrived At Destination location">گاڑی منزل پر پہنچ گئی ہے</option>
                {/* <option value="Job Completed Successfully"> کام پورا ہوگیا</option> */}
              </select>
            </div>        
                <button  onClick={() => updateDriverStatusHandler(order?._id)}  className="btn update-btn w-100 py-2">
                 Update
                 </button>
            </td>
              </tr>
            )}

              <tr>
                <th scope="row"><h5>سواری کی قیمت</h5></th>
                <td>{totalAmount} PKR</td>
              </tr>

              <tr>
              <th scope="row"><h5> 📞 فون نمبر</h5></th>
              <td>0{order?.phoneNo}</td>
            </tr>



              {/* {order?.orderStatus === "Waiting for driver's proposal amount" && (
              <tr>
                <th scope="row"><h5>آپ کی منگی ہوئی رقم</h5></th>
                <td>
                  <input
                    type="number"
                    id="adminProposedAmount_field"
                    className="form-control"
                    name="adminProposedAmount_field"
                    value={adminProposedAmount}
                    required
                    onChange={(e) => setAdminProposedAmount(e.target.value)}
                  />
                  <br />

                  <button
                    className="btn btn-primary w-100"
                    onClick={() => updateProposedOrderHandler(order?._id)}
                  >
                    Submit
                  </button> 

          <br></br>
          <br></br>
 
                </td>
              </tr>
              )} */}

            </tbody>
          </table>

          <table className="table table-striped table-bordered">
            <tbody>
            <h3 className="mt-5 mb-4">Ride Details</h3>
              <tr>
                <th scope="row">ID</th>
                <td>{order?._id}</td>
              </tr>

              <tr>
                <th scope="row">Ride Status</th>
                <td
                  
                >
                  <b>{orderStatus}</b>
                </td>
              </tr>

              <tr>
              <th scope="row">Booking Type</th>
              <td>{userAddressInfo?.bookingType}</td>
            </tr>

            <tr>
              <th scope="row">Load Type</th>
              <td>{userAddressInfo?.loadType}</td>
            </tr>

              <tr>
                <th scope="row">Distance From Start-Destination</th>
                <td>
                <b>{googleMap?.distance}</b>
                </td>
              </tr>

              <tr>
              <th scope="row">Vehicle Needed</th>
              <td>{userAddressInfo?.vehicle}</td>
            </tr>

            </tbody>
          </table>

          <h3 className="mt-5 mb-4">Goods Info</h3>
          <table className="table table-striped table-bordered">
            <tbody>
            <tr>
                <th scope="row">Type Of Goods</th>
                <td>
                <td>{goodsInfo?.goodsType}</td>
                </td>
              </tr>

              <tr>
                <th scope="row">Total Weight</th>
                <td>
                <td>{goodsInfo?.totalWeight} KG'S</td>
                </td>
              </tr>

              <tr>
                <th scope="row">Volume</th>
                <td>
                <td>{goodsInfo?.volume} <b>𝑚<sup>3</sup></b></td>
                </td>
              </tr>
                            
              <tr>
                <th scope="row">Load Type</th>
                <td>
                <td>{goodsInfo?.loadingType} </td>
                </td>
              </tr>
              </tbody>
              </table>

          <h3 className="mt-5 mb-4">Address on Google Maps</h3>
          <table className="table table-striped table-bordered">
            <tbody>
            <tr>
                <th scope="row">Starting Address</th>
                <td>
                <td>{googleMap?.origin},</td>
                </td>
              </tr>

              <tr>
                <th scope="row">Destination Address</th>
                <td>
                <td>{googleMap?.destination},</td>
                </td>
              </tr>
              <tr>
                <th scope="row">Distance from Start-Destiantion</th>
                <td>
                <td>{googleMap?.distance},</td>
                </td>
              </tr>
              </tbody>
              </table>

              <h3 className="mt-5 mb-4">Further Address Info</h3>
          <table className="table table-striped table-bordered">
            <tbody>
            <tr>
                <th scope="row">Starting Address</th>
                <td>
                <td>{userAddressInfo?.startAddress}, {userAddressInfo?.startCity}</td>
                </td>
              </tr>

              <tr>
                <th scope="row">Destination Address</th>
                <td>
                <td>{userAddressInfo?.destinationAddress}, {userAddressInfo?.destinationCity}</td>
                </td>
              </tr>
                
            <tr>
              <th scope="row">Phone No</th>
              <td>0{order?.phoneNo}</td>
            </tr>
            </tbody>
          </table>
          
              <h3 className="mt-5 mb-4">Labour Detail</h3>
          <table className="table table-striped table-bordered">
            <tbody>
            <tr>
                <th scope="row">Labours needed at starting address</th>
                <td>
                <td>{labour?.noOfLaboursStart || 0}</td>
                </td>
              </tr>

              <tr>
                <th scope="row">Labours needed at Destination address</th>
                <td>
                <td>{labour?.noOfLaboursDestination || 0}</td>
                </td>
              </tr>

              <tr>
                <th scope="row">Number of floors at start address</th>
                <td>
                <td>{labour?.buildingFloorsStart || 0} </td>
                </td>
              </tr>

                            
              <tr>
                <th scope="row">Number of floors at destination address</th>
                <td>
                <td>{labour?.buildingFloorsDestination || 0} </td>
                </td>
              </tr>

              <tr>
                <th scope="row">Cargo Lift at start address</th>
                <td>
                <td>{labour?.cargoLiftStart ? "Yes" : "No"}</td>
                </td>
              </tr>

              
              <tr>
                <th scope="row">Cargo Lift at destination address</th>
                <td>
                <td>{labour?.cargoLiftDestination ? "Yes" : "No"}</td>
                </td>
              </tr>
              </tbody>
              </table>

 {order?.orderStatus === "Finding Driver" && (
    <div className="text-center my-4">
      <button
        type="button"
        id="accept_btn"
        className="btn btn-primary btn-lg px-5 py-3 fs-2"
      onClick={() => {
        acceptBooking(order?._id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}      
      >
        بکنگ شروع کریں
      </button>
    </div>
)}


          <br></br>          
          <br></br>
          <br></br>

        </div>

      </div>
      </>
  )
}

export default PotentialBookingDetails
